(function () {
  if (customElements.get('wss-collection')) return;

  class WssCollection extends HTMLElement {
    connectedCallback() {
      this._onKeydown = this._onKeydown.bind(this);
      this._onClick = this._onClick.bind(this);
      this._onChange = this._onChange.bind(this);
      this._onSubmit = this._onSubmit.bind(this);

      this.addEventListener('click', this._onClick);
      this.addEventListener('change', this._onChange);
      this.addEventListener('submit', this._onSubmit);
      document.addEventListener('keydown', this._onKeydown);

      const section = this.closest('.shopify-section');
      this.sectionId = section ? section.id.replace('shopify-section-', '') : null;

      this._initGalleries();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKeydown);
    }

    _openFilter() {
      const filter = this.querySelector('[data-wss-filter]');
      if (!filter) return;
      filter.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    _closeFilter() {
      const filter = this.querySelector('[data-wss-filter]');
      if (!filter) return;
      filter.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    _onKeydown(e) {
      if (e.key === 'Escape') this._closeFilter();
    }

    _onChange(event) {
      if (event.target.closest('[data-wss-filter-form]')) this._applyFilters();
    }

    _onSubmit(event) {
      if (event.target.closest('[data-wss-filter-form]')) {
        event.preventDefault();
        this._applyFilters();
      }
    }

    _applyFilters() {
      const form = this.querySelector('[data-wss-filter-form]');
      if (!form) return;

      const params = new URLSearchParams();
      new FormData(form).forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });

      const base = form.getAttribute('action') || window.location.pathname;
      const search = params.toString();
      const url = search ? `${base}?${search}` : base;

      this._navigate(url);
    }

    _navigate(url) {
      const [base, search = ''] = url.split('?');

      if (!this.sectionId) {
        window.location.href = url;
        return;
      }

      history.replaceState({}, '', url);

      if (this._abort) this._abort.abort();
      this._abort = new AbortController();

      const col = this.querySelector('.wss-col');
      if (col) col.classList.add('is-loading');

      fetch(`${base}?${search ? search + '&' : ''}section_id=${this.sectionId}`, { signal: this._abort.signal })
        .then((response) => response.text())
        .then((text) => this._renderResults(text))
        .catch((error) => {
          if (error.name !== 'AbortError') window.location.href = url;
        });
    }

    _renderResults(text) {
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const newCol = doc.querySelector('.wss-col');
      const col = this.querySelector('.wss-col');
      if (newCol && col) col.replaceWith(newCol);

      const newForm = doc.querySelector('[data-wss-filter-form]');
      const form = this.querySelector('[data-wss-filter-form]');
      if (newForm && form) {
        const openGroups = Array.from(form.querySelectorAll('details')).map((d) => d.open);
        form.innerHTML = newForm.innerHTML;
        form.querySelectorAll('details').forEach((d, i) => {
          if (typeof openGroups[i] === 'boolean') d.open = openGroups[i];
        });
      }

      this._initGalleries();
    }

    _onClick(event) {
      if (event.target.closest('[data-wss-filter-open]')) {
        this._openFilter();
        return;
      }

      if (event.target.closest('[data-wss-filter-close]') || event.target.closest('[data-wss-filter-overlay]')) {
        this._closeFilter();
        return;
      }

      const facetRemove = event.target.closest('[data-wss-facet-remove]');
      if (facetRemove) {
        event.preventDefault();
        const href = facetRemove.getAttribute('href');
        if (href) this._navigate(href);
        return;
      }

      const clear = event.target.closest('[data-wss-filter-clear]');
      if (clear) {
        event.preventDefault();
        const form = this.querySelector('[data-wss-filter-form]');
        if (form) {
          form.querySelectorAll('input[type="checkbox"]').forEach((input) => (input.checked = false));
          form.querySelectorAll('input[type="number"]').forEach((input) => (input.value = ''));
        }
        this._applyFilters();
        return;
      }

      const dot = event.target.closest('[data-pc-dot]');
      if (dot) {
        event.preventDefault();
        event.stopPropagation();
        const media = dot.closest('[data-pc-media]');
        const gallery = media && media.querySelector('[data-pc-gallery]');
        if (gallery) {
          const index = parseInt(dot.dataset.index, 10) || 0;
          gallery.scrollTo({ left: index * gallery.clientWidth, behavior: 'smooth' });
        }
        return;
      }

      const swatch = event.target.closest('[data-pc-swatch]');
      if (swatch) {
        event.preventDefault();
        const card = swatch.closest('[data-pc-card]');
        if (!card) return;
        const media = card.querySelector('[data-pc-media]');
        const gallery = card.querySelector('[data-pc-gallery]');

        let images = null;
        if (swatch.dataset.images) {
          try {
            images = JSON.parse(swatch.dataset.images);
          } catch (e) {
            images = null;
          }
        }

        if (gallery && images && images.length) {
          this._rebuildGallery(media, gallery, images);
        } else if (gallery) {
          const image = card.querySelector('[data-pc-main-image]');
          if (image && swatch.dataset.image) {
            if (swatch.dataset.srcset) image.setAttribute('srcset', swatch.dataset.srcset);
            else image.removeAttribute('srcset');
            image.setAttribute('src', swatch.dataset.image);
          }
          this._jumpTo(gallery, 0);
          this._applyMediaState(media, 0);
        }

        if (swatch.dataset.url) {
          card.querySelectorAll('[data-pc-link]').forEach((l) => l.setAttribute('href', swatch.dataset.url));
        }
        card.querySelectorAll('[data-pc-swatch]').forEach((s) => {
          s.classList.toggle('is-active', s === swatch);
          s.setAttribute('aria-pressed', s === swatch);
        });
      }
    }

    _applyMediaState(media, index) {
      if (!media) return;
      const dots = media.querySelectorAll('[data-pc-dot]');
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }

    _rebuildGallery(media, gallery, images) {
      const oldImg = gallery.querySelector('img');
      const sizes = oldImg ? oldImg.getAttribute('sizes') : null;
      const alt = oldImg ? oldImg.getAttribute('alt') : '';

      gallery.innerHTML = '';
      images.forEach((img, i) => {
        const item = document.createElement('div');
        item.className = 'wss-card__gallery-item';
        const el = document.createElement('img');
        if (i === 0) el.setAttribute('data-pc-main-image', '');
        el.src = img.src;
        if (img.srcset) el.setAttribute('srcset', img.srcset);
        if (sizes) el.setAttribute('sizes', sizes);
        el.alt = alt || '';
        if (img.w) el.width = img.w;
        if (img.h) el.height = img.h;
        el.loading = 'lazy';
        item.appendChild(el);
        gallery.appendChild(item);
      });
      this._jumpTo(gallery, 0);

      const hoverImage = media ? media.querySelector('[data-pc-hover-image]') : null;
      const hoverWrap = media ? media.querySelector('[data-pc-hover]') : null;
      if (hoverWrap && hoverImage) {
        const next = images[1];
        if (next) {
          hoverImage.src = next.src;
          if (next.srcset) hoverImage.setAttribute('srcset', next.srcset);
          else hoverImage.removeAttribute('srcset');
          hoverWrap.style.display = '';
        } else {
          hoverWrap.style.display = 'none';
        }
      }

      const dotsWrap = media ? media.querySelector('[data-pc-dots]') : null;
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        if (images.length > 1) {
          images.forEach((_, i) => {
            const dot = document.createElement('span');
            dot.className = 'wss-card__dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('data-pc-dot', '');
            dot.setAttribute('data-index', i);
            dotsWrap.appendChild(dot);
          });
          dotsWrap.style.display = '';
        } else {
          dotsWrap.style.display = 'none';
        }
      }

      this._applyMediaState(media, 0);
    }

    _canHover() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    _jumpTo(gallery, left) {
      const previous = gallery.style.scrollBehavior;
      gallery.style.scrollBehavior = 'auto';
      gallery.scrollLeft = left;
      gallery.style.scrollBehavior = previous;
    }

    _exitPreview(media, gallery, reset) {
      if (media._pcSnapTimer) {
        clearTimeout(media._pcSnapTimer);
        media._pcSnapTimer = null;
      }
      const wasPreview = media.hasAttribute('data-pc-preview');
      media.removeAttribute('data-pc-preview');
      media.removeAttribute('data-pc-snapped');
      if (wasPreview && reset) {
        this._jumpTo(gallery, 0);
        media.removeAttribute('data-pc-scrolled');
        this._applyMediaState(media, 0);
      }
    }

    _initGalleries() {
      this.querySelectorAll('[data-pc-gallery]').forEach((gallery) => {
        if (gallery.dataset.pcReady) return;
        gallery.dataset.pcReady = 'true';
        const media = gallery.closest('[data-pc-media]');
        if (!media) return;
        this._applyMediaState(media, 0);

        media.addEventListener('mouseenter', () => {
          if (!this._canHover()) return;
          if (media.querySelectorAll('.wss-card__gallery-item').length < 2) return;
          if (gallery.scrollLeft > 4) return;
          media.setAttribute('data-pc-preview', '');
          media.removeAttribute('data-pc-scrolled');
          this._applyMediaState(media, 1);
          media._pcSnapTimer = setTimeout(() => {
            media._pcSnapTimer = null;
            if (!media.hasAttribute('data-pc-preview')) return;
            media.setAttribute('data-pc-snapped', '');
            this._jumpTo(gallery, gallery.clientWidth);
          }, 550);
        });

        media.addEventListener('mouseleave', () => {
          this._exitPreview(media, gallery, true);
        });

        let raf = null;
        gallery.addEventListener(
          'scroll',
          () => {
            if (raf) return;
            raf = requestAnimationFrame(() => {
              raf = null;
              const width = gallery.clientWidth;
              const index = Math.round(gallery.scrollLeft / width);
              this._applyMediaState(media, index);
              const base = media.hasAttribute('data-pc-snapped') ? width : 0;
              if (Math.abs(gallery.scrollLeft - base) > 4) {
                this._exitPreview(media, gallery, false);
                media.setAttribute('data-pc-scrolled', '');
              } else if (!media.hasAttribute('data-pc-preview')) {
                media.toggleAttribute('data-pc-scrolled', gallery.scrollLeft > 4);
              }
            });
          },
          { passive: true }
        );
      });
    }
  }

  customElements.define('wss-collection', WssCollection);
})();